const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

/* -------------------------------
   INIT
--------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const recommendations = document.getElementsByClassName('product-recommendations');
  const len = recommendations.length;

  if (!len) initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  initGrid();
});

/* -------------------------------
   FETCH PRODUCT CARD
--------------------------------*/
const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;

  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(res, 'text/html');
      const productCard = htmlDocument.querySelector(selectors.productCard);
      return productCard?.outerHTML || '';
    })
    .catch((err) =>
      console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err)
    );
};

/* -------------------------------
   GRID SETUP
--------------------------------*/
const setupGrid = async (grid) => {
  const wishlist = getWishlist();

  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);

  grid.innerHTML = responses.join(' ');
  grid.classList.add(GRID_LOADED_CLASS);

  initButtons();

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist },
    })
  );
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);
};

/* -------------------------------
   BUTTONS
--------------------------------*/
const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle;

    if (!productHandle) {
      console.error(
        '[Shopify Wishlist] Missing data-product-handle attribute.'
      );
      return;
    }

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }

    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button);

  if (!buttons.length) return;

  setupButtons(buttons);

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:init-buttons', {
      detail: { wishlist: getWishlist() },
    })
  );
};

/* -------------------------------
   WISHLIST STORAGE
--------------------------------*/
const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
};

const setWishlist = (array) => {
  if (array.length) {
    localStorage.setItem(
      LOCAL_STORAGE_WISHLIST_KEY,
      array.join(LOCAL_STORAGE_DELIMITER)
    );
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:updated', {
      detail: { wishlist: array },
    })
  );

  updateWishlistCount();

  return array;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);

  if (index === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(index, 1);
  }

  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  return getWishlist().includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

/* -------------------------------
   UI COUNT
--------------------------------*/
const updateWishlistCount = () => {
  const wishlist = getWishlist();

  $('[data-js-wishlist-count]')
    .attr('data-js-wishlist-count', wishlist.length)
    .html(wishlist.length);

  if (wishlist.length === 0) {
    $('.wish-info').css('display', 'block');
  } else {
    $('.wish-info').css('display', 'none');
  }
};

/* -------------------------------
   READY
--------------------------------*/
$(document).ready(function () {
  updateWishlistCount();
});